import React from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { formatDateTime } from "../common-data/Converts";

const SubscriptionExtensionTable = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { subscriptionExtensionRequests, subscriptionExtensionRequestsLoading } = useSelector(
    (state) => state.plans
  );

  const isLoading = subscriptionExtensionRequestsLoading;
  const tableData = subscriptionExtensionRequests?.data || [];
  
  const paginationData = subscriptionExtensionRequests?.pagination?.[0] || {};
  const pagination = [paginationData]; 
  

  const tableColumns = [
    { 
      dataField: "member_details", 
      text: "Member Details", 
      formatter: (_, row) => (
        <div>
          <div className="tb-data minWidth150 font-weight-bold">{row?.name || "N/A"}</div>
          <div className="tb-data minWidth150 text-muted">{row?.mobile || "N/A"}</div>
        </div>
      ), 
    },
    { 
      dataField: "gym_name", 
      text: "Gym Name", 
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "N/A"}</span>
      ), 
    },
    { 
      dataField: "extend_days", 
      text: "Extend Days", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{row?.extend_days || "N/A"} days</span>
      ), 
    },
    { 
      dataField: "added_by", 
      text: "Added By", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{row?.added_by_name || "N/A"}</span>
      ), 
    },
    { 
      dataField: "date_added", 
      text: "Date Added", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{ formatDateTime(row?.date_added) || "-"}</span>
      ), 
    },
    { 
      dataField: "plan_details", 
      text: "Plan Details", 
      formatter: (_, row) => (
        <div>
          <div className="tb-data minWidth150"><strong>Plan:</strong> {row?.plan_name || "N/A"}</div>
          <div className="tb-data minWidth150"><strong>Duration:</strong> {row?.duration || "0"} days</div>
          <div className="tb-data minWidth150"><strong>Amount:</strong> ₹ {row?.price || "0"}</div>
        </div>
      ), 
    },
    { 
      dataField: "rejection_reason", 
      text: "Rejection Reason", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{row?.reject_reason || "NA"}</span>
      ), 
    },
    { 
      dataField: "approved_by", 
      text: "Approved By", 
      formatter: (_, row) => (
        <span className="tb-data minWidth120">{row?.approved_by_name || "NA"}</span>
      ), 
    },
    {
      dataField: "status",
      text: "Approval Status",
      formatter: (_, row) => {
        let badgeStyle = {};
        let badgeText = "";
        
        if (row?.status === "approved") {
          badgeStyle = {
            backgroundColor: "#28a745",
            color: "white",
            padding: " 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold",
            border: "none"
          };
          badgeText = "Approved";
        } else if (row?.status === "pending") {
          badgeStyle = {
            backgroundColor: "#ffc107",
            color: "#212529",
            padding: " 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold",
            border: "none"
          };
          badgeText = "Pending";
        } else {
          badgeStyle = {
            backgroundColor: "#dc3545",
            color: "white",
            padding: " 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold",
            border: "none"
          };
          badgeText = "Rejected";
        }
        
        return (
          <span style={badgeStyle}>
            {badgeText}
          </span>
        );
      },
    },
  ];

  if (isLoading) { 
    return <ReactVortoxSpinner />; 
  }
  
  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable mt15">
      <PaymentLinkTable 
        tableData={tableData} 
        tableColumns={tableColumns} 
        tablePagination={pagination} 
        isPage={isPage} 
        setIsPage={setIsPage} 
        pageLimit={pageLimit} 
        setPageLimit={setPageLimit} 
      />
    </div>
  );
};

export default SubscriptionExtensionTable;
